import React from 'react';
import { Icon } from 'semantic-ui-react';
import './AddDashedOutlineButton.scss';

/**
 * Dashed outline action (e.g. "Agregar cuenta", "Agregar excepción").
 * Shared styling between journal entry and rule modals.
 */
const AddDashedOutlineButton = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  className = '',
  icon = 'plus',
}) => (
  <button
    type={type}
    className={`add-dashed-outline-button ${className}`.trim()}
    onClick={onClick}
    disabled={disabled}
  >
    {icon ? <Icon name={icon} /> : null}
    {children}
  </button>
);

export default AddDashedOutlineButton;
